import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import API from '../api';

const PLANS = [
  { id:'basic', name:'⭐ 基础', price:'$4.99', badge:'⭐', period:'/月',
    features:['无限翻译消息', '90天消息保存', '优先匹配推荐', '无广告体验', '基础徽章'],
    color:'#667eea' },
  { id:'vip', name:'👑 VIP', price:'$9.99', badge:'👑', period:'/月', popular:true,
    features:['无限翻译消息', '永久消息保存', '🔥 超级曝光', '💬 已读回执', '🎁 专属VIP徽章', '🚫 无广告', '优先客服'],
    color:'#f59e0b' },
];

const GIFT_ITEMS = [
  { emoji:'🌹', name:'玫瑰', price:'$1.00', desc:'打招呼时附赠玫瑰，让对方感受到你的心意' },
  { emoji:'💎', name:'钻石', price:'$3.00', desc:'消息置顶7天，再也不会被淹没' },
  { emoji:'👑', name:'皇冠', price:'$10.00', desc:'超级曝光 + 翻译特效，让对方一眼注意到你' },
];

export default function PricingPage() {
  const [membership, setMembership] = useState(null);
  const [loading, setLoading] = useState(null);
const [payMethod, setPayMethod] = useState(null);
  const [qrUrls, setQrUrls] = useState({});
const [payPlan, setPayPlan] = useState(null);
const [txId, setTxId] = useState('');
  const [msg, setMsg] = useState('');
  const [coinLoading, setCoinLoading] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => { const p=new URLSearchParams(window.location.search), orderId=p.get('token'), packId=p.get('pack'); if(p.get('coins')==='1'&&orderId&&packId){ setCoinLoading(true); API.post('/revenue/coins/paypal-capture',{orderId,packId}).then(()=>setMsg('🎉 心动币已到账！')).catch(e=>setMsg(e.response?.data?.error||'心动币支付确认失败')).finally(()=>{setCoinLoading(false);window.history.replaceState({},document.title,'/pricing');}); } }, []);

  useEffect(() => {
    // 检查 PayPal 支付回调
    const params = new URLSearchParams(window.location.search);
    const isPaypal = params.get('paypal');
    const token = params.get('token');
    const planId = params.get('plan');

    if (isPaypal && token && planId) {
      setLoading('capturing');
      API.post('/payments/paypal-capture', { orderId: token, planId })
        .then(res => {
          setMsg('🎉 支付成功！会员已激活');
          fetch('/api/analytics/event',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({event:'membership_purchase_complete',path:window.location.pathname})}).catch(()=>{});
          window.history.replaceState({}, document.title, '/pricing');
          return API.get('/membership/status');
        })
        .then(r => { setMembership(r.data); setLoading(null); })
        .catch(err => {
          setMsg('支付确认失败: ' + (err.response?.data?.error || err.message));
          setLoading(null);
          window.history.replaceState({}, document.title, '/pricing');
        });
    } else {
      // 正常加载会员状态
      API.get('/membership/status').then(r => setMembership(r.data)).catch(() => {});
    }
  }, []);
  

  const subscribe = (planId) => { doPaypal(planId); };
  
  const doPaypal = async (planId) => {
    setLoading(planId);
    try {
      const res = await API.post('/payments/create-checkout', { planId });
      if (res.data.url) { window.location.href = res.data.url; return; }
      setMsg('支付创建失败');
    } catch(e) { setMsg('操作失败'); }
    setLoading(null);
  };
  
  const doManualPay = async () => {
    if (!txId.trim()) { setMsg('请填写交易单号'); return; }
    setLoading('manual');
    try {
      const res = await API.post('/payments/manual-order', {
        type: 'membership', planId: payPlan, method: payMethod, transactionId: txId
      });
      setMsg(res.data.message);
      setPayMethod(null); setPayPlan(null); setTxId('');
    } catch(e) { setMsg(e.response?.data?.error || '提交失败'); }
    setLoading(null);
  };

  const buyStarterCoins = async () => { setCoinLoading(true); setMsg(''); try { const res=await API.post('/revenue/coins/paypal-order',{packId:'starter'}); if(res.data.url) window.location.href=res.data.url; else setMsg('无法创建心动币支付订单'); } catch(e) { setMsg(e.response?.data?.error||'无法创建心动币支付订单'); } finally { setCoinLoading(false); } };

  const isSubscribed = (planId) => membership?.tier === planId && membership?.subscription;
  const currentTier = membership?.tier || 'free';
  const planOrder = ['free', 'basic', 'vip'];

  return (
    <div className="page-content">
      {/* 当前状态 */}
      <div className="discovery-header">
        <h2>{membership?.badge || '🌍'} 会员中心</h2>
        <p className="subtitle">
          {currentTier === 'free' ? '当前是免费用户 · 每天20条翻译' : `当前是 ${membership?.label} 会员 · 无限翻译`}
          {membership?.quota?.daily > 0 && ` · 今日剩余 ${membership.quota.remaining} 条`}
        </p>
        {membership?.subscription && (
          <p style={{ fontSize:'0.8rem', color:'var(--text-dim)', marginTop:4 }}>
            {membership.subscription.endDate ? `有效期至 ${new Date(membership.subscription.endDate).toLocaleDateString('zh-CN')}` : ''}
          </p>
        )}
      </div>

      {payPlan && !payMethod && (
        <div className="card form-card" style={{maxWidth:400,margin:'0 auto 16px',textAlign:'center'}}>
          <h3 style={{marginBottom:16}}>选择支付方式</h3>
          <div style={{display:'flex',flexDirection:'column',gap:8}}>
            <button className="btn btn-primary" onClick={() => doPaypal(payPlan)} style={{padding:12}}>💳 PayPal 支付</button>
            <button className="btn btn-secondary" onClick={() => setPayMethod('alipay')} style={{padding:12}}>📱 支付宝</button>
            <button className="btn btn-secondary" onClick={() => setPayMethod('wechat')} style={{padding:12}}>💚 微信支付</button>
          </div>
          <button className="btn btn-secondary" onClick={() => setPayPlan(null)} style={{marginTop:12,fontSize:'0.8rem'}}>取消</button>
        </div>
      )}
      {payMethod && (
        <div className="card form-card" style={{maxWidth:400,margin:'0 auto 16px',textAlign:'center'}}>
          <h3 style={{marginBottom:8}}>📱 {payMethod === 'alipay' ? '支付宝' : '微信'}扫码支付</h3>
          <p style={{fontSize:'0.85rem',color:'var(--text-dim)',marginBottom:12}}>
            请用{payMethod === 'alipay' ? '支付宝' : '微信'}扫码支付 <strong>¥{payPlan === 'basic' ? '35' : '72'}</strong>
          </p>
          <div style={{width:200,height:200,margin:'0 auto 16px',borderRadius:12,overflow:'hidden',background:'#2a2a3e',display:'flex',alignItems:'center',justifyContent:'center'}}>
            {qrUrls[payMethod] ? <img src={qrUrls[payMethod]} style={{width:'100%',height:'100%',objectFit:'contain'}} /> : <span style={{fontSize:'0.8rem',color:'#555'}}>收款码加载中...</span>}
          </div>
          <input placeholder="输入交易单号" value={txId} onChange={e => setTxId(e.target.value)}
            style={{width:'100%',padding:10,borderRadius:8,border:'1px solid var(--border)',background:'var(--bg)',color:'var(--text)',marginBottom:8}} />
          <div style={{display:'flex',gap:8}}>
            <button className="btn btn-primary" onClick={doManualPay} disabled={loading==='manual'} style={{flex:1}}>
              {loading==='manual' ? '提交中...' : '已付款，提交确认'}
            </button>
            <button className="btn btn-secondary" onClick={() => setPayMethod(null)}>返回</button>
          </div>
        </div>
      )}
      {msg && <div className="alert" style={{ background:'rgba(74,222,128,0.15)', color:'#4ade80', textAlign:'center', marginBottom:20, border:'1px solid rgba(74,222,128,0.2)' }}>{msg}</div>}

      {/* 套餐卡片 */}
      <div className="plans-grid">
        {PLANS.map(plan => {
          const subbed = isSubscribed(plan.id);
          const myPlan = planOrder.indexOf(currentTier) >= planOrder.indexOf(plan.id);
          return (
            <div key={plan.id} className={`plan-card ${plan.popular ? 'popular' : ''} ${subbed ? 'owned' : ''}`}>
              {plan.popular && <div className="plan-badge">🔥 最受欢迎</div>}
              {subbed && <div className="plan-badge owned-badge">✅ 当前套餐</div>}
              <div className="plan-header">
                <div className="plan-name">{plan.name}</div>
                <div className="plan-price">
                  <span className="price-num">{plan.price}</span>
                  <span className="price-period">{plan.period}</span>
                </div>
              </div>
              <ul className="plan-features">
                {plan.features.map((f,i) => <li key={i}>{f}</li>)}
              </ul>
              <button className={`btn btn-plan ${subbed ? 'btn-owned' : myPlan && !subbed ? 'btn-secondary' : plan.popular ? 'btn-primary' : 'btn-secondary'}`}
                onClick={() => subscribe(plan.id)} disabled={loading===plan.id || subbed}>
                {loading === plan.id ? '处理中...' : subbed ? '已订阅 ✓' : myPlan && !subbed ? '已拥有' : '立即订阅'}
              </button>
            </div>
          );
        })}
      </div>

      <div className="gifts-section"><h3 style={{textAlign:'center',marginBottom:8}}>💗 Heart Coin checkout</h3><p style={{textAlign:'center',color:'var(--text-dim)',marginTop:0}}>用心动币送礼物，让喜欢被看见。</p><div style={{display:'flex',justifyContent:'center'}}><div className="gift-card" style={{maxWidth:240}}><div className="gift-emoji">💗</div><div className="gift-name">120 心动币</div><div className="gift-price">$1.99</div><button className="btn btn-primary" style={{marginTop:10}} onClick={buyStarterCoins} disabled={coinLoading}>{coinLoading ? '处理中...' : '购买心动币'}</button></div></div></div>

      {/* 虚拟礼物 */}
      <div className="gifts-section">
        <h3 style={{ textAlign:'center', marginBottom:16 }}>🎁 虚拟礼物</h3>
        <div className="gifts-grid">
          {GIFT_ITEMS.map(g => (
            <div key={g.name} className="gift-card">
              <div className="gift-emoji">{g.emoji}</div>
              <div className="gift-name">{g.name}</div>
              <div className="gift-price">{g.price}</div>
              <div className="gift-desc">{g.desc}</div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ textAlign:'center', margin:'40px 0' }}>
        <button className="btn btn-secondary" onClick={() => navigate('/discover')}>
          🌐 返回探索
        </button>
      </div>
    </div>
  );
}
